
    
  import React, { useReducer } from "react";
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuDropdown  from "components/nubox/NuDropdown";
  import NuInputBox from "components/nubox/Box/NuInputBox";

  import ImageUpload from "components/nubox/ImageUpload";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import ModalProgramacion from '../programacion_crud/ModalProgramacion'

  import { withRouterJim } from "router/withRouterJim";
  
  import user2 from "assets/img/user2.png"

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";

  const cbo=[
    {  value:'1', label: 'label1'},
  ]
  
  const initialForm={
    id_u:'',
    nro_doc:'',
    nomape_tmp:'',
    dir:'',
    tel:'',
    foto_path1:'',
    estado:0,
  }
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class PrograCambiaGrupo extends React.Component {
    modalRef = React.createRef();//create ref

    state = {
      modalInsertar: false, //box materia
      materia_selected:{}, //seleccionada del box

      modalImagen: false,
      id_est:0,  //desde parametros
      id_peri:0,  //desde parametros
      
      form: Object.assign({}, initialForm),
        
      data: [],/* tabla  */
      options:[{  value:1, label: '1'},
        {  value:2, label: '2'},
        {  value:3, label: '3'},
        {  value:4, label: '4'},
      ]
      
    };
    //--------------------------------------
    constructor(props) {
      super(props);

      this.refNuConfirm = React.createRef();
    }
    //------------------
    //---------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});
  
      // Get the userId param from the URL.
      
      let id_peri = this.props.store.user.id_peri;
            
      //this.cargar_estudiante(id_est); //carga datos del estudiante
      //this.cargar_data(id_est, id_peri); //carga del periodo de el store
            
      //---actualizamos el estado
      this.setState({id_est: 0, id_peri: id_peri})
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      
      //--- esto lo hacemos porque en vez de utilizar valores true, false
      //--- tenemos que utilizar 1, 0
      if(e.target.type==="checkbox"){

        let res = e.target.checked? 1:0;        
        this.setState({
          form:{
            ...this.state.form,
            [e.target.name]: res,
          }
        })
      }else{
        this.setState({
          form: {
            ...this.state.form,
            [e.target.name]: e.target.value,
          },
        });
      }
    };

    buscar_estudiante = (nro_doc) => {      
      console.log("buscar_estudiante");
      let param = { 
        nro_doc: nro_doc,
      }
      console.log(param);
      axios2.post( "progra_cambia_grupo_buscar_est_x_ci", param)
      .then(res => {
          console.log(res.data);
          if( res.data!==''){ 
              //cargamos el estudiante
              this.setState({
                form: {  ...res.data,  },
              });
              //------------ tambien cargamos su programcion
              this.cargar_data( res.data.id_est, this.state.id_peri);
              //--------------------------------------------------
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
    //-----------------------------------------
    //---carga la programacion del estudiante
    cargar_data = (id_est, id_peri) => {      
  
      let param = { 
        id_est: id_est,
        id_peri: id_peri,
      }
      console.log(param);
      axios2.post( "progra_cambia_grupo_get_programacion", param)
      .then(res => {
          console.log(res.data);
          if( res.data!==''){ 
              //cargamos el estudiante
              this.setState({  data: res.data  });
              
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };

    //-------------------MODAL----------------------------------------------
    editar = (item) =>{
      console.log('editar');
      //    console.log(item);
      let idd = item.id_progra;
      this.modalRef.current.editar(idd);
    }
    //-----------------------------------------------------------------
    eliminar = (item) =>{
      console.log('eliminar');
      
      this.refNuConfirm.current.show({
        message: 'Esta seguro de eliminar?',
        title: 'Confirmar',
        icon: 'fa fa-question-circle',
        classHeader: 'bg-default1 ',
        classButton: 'btn btn-danger',
        accept: () => {
          let idd = item.id_progra;
          this.modalRef.current.eliminar(idd);
        },
        reject: () => {
            console.log('cancel');
        },
        acceptLabel: 'Aceptar',
        rejectLabel: 'Cancelar'
      })
  
    }
    //-------------------------------------
    okModal =()=>{
      console.log('citaOkModal');
      toast.success("Modificado con éxito")
      this.cargar_data( this.state.form.id_est, this.state.id_peri);
    }
    //-------------------------------------
    closeModal =()=>{
      console.log('citaCancelModal');
    }
    //-------------
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_form();
    }

  //***********DATATABLE**** */
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.data];
    newData[index][columnId] = value;
    
    console.log(newData);
    //setData({  data: newData    });
    this.setState({ data: newData });
  }
  //---------------------------------
  /******************************************** */
  //---buscamos los datos de un estudiante preinscrito
  buscarClick =()=>{
    console.log("buscar")
    this.setState({modalShow:true});

    
  }
  handleOK=(cad)=>{  
    //e.preventDefault();
    console.log("cad="+cad)
    this.setState({ modalShow: false});
    
    //let fileURL = "/certificado1/"+ cad+"/e";
    //navigate(fileURL);
    //window.location= fileURL;
    this.buscar_estudiante(cad);
    //this.cargar_estudiante (cad);
  }
  handleCancel=()=>{ 
    this.setState({ modalShow: false});
  }
  /************************************************ */
  //----------------------------
  saveNew =(item) =>{    
    let param =  { id_peri: this.state.id_peri ,
                    id_carre: 1, 
                    id_est: this.state.id_est,	
                    id_mate: item.id_mate};
    console.log(param);

    axios2.post("programacion_savenew", param)
    .then(res => {
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);
            //--- tenemos que redireccionar
            this.cargar_data(this.state.id_est, this.state.id_peri);
            //this.props.navigate('/DocenteList');
        }else{
            toast.error(res.data.mensaje);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  
  }
  //----------------------------
  
    
    //------------------------------
    render() {
      return (
        <div>
          <ToastContainer />
          <div className="content">

            {/* ---   --- */}
            <section className="content-header">
              <div className="" style={{ textAlign:'center' }}>
                <h3 className="text-muted">Programación cambio de grupo</h3>
              </div>
              {/**/}

              <div className="card" style={{width: 350}}>
                <div className="col-sm-12">
                    <h5 className="titulo_card" style={{color: 'grey'}}><i>Estudiante</i></h5>
                    
                    <div className="right col-xs-5 text-center"> 
                      {this.state.form.foto_path1 !== ''? (
                        <img src={process.env.REACT_APP_AFILES + this.state.form.foto_path1}
                                  className="avatar img-circle2 img-responsive"
                                  alt="Foto" />
                      ):(
                        <img src={user2} className="avatar" alt="Foto" height="80px"/>
                      )
                      }
                    </div>
                    <div className="left col-xs-7">
                        <h5>{ this.state.form.nomape_tmp }                         </h5>
                        <ul className="list-unstyled">
                            <li><i className="fa fa-home"></i> { this.state.form.dir }    </li>
                            <li><i className="fa fa-phone"></i> { this.state.form.tel } </li>
                            <li><i className="fa "></i><b>C.I.</b> { this.state.form.nro_doc } </li>
                        </ul>
                    </div>
                </div>
                <div className="col-xs-12 bottom text-center">
                  <button className="btn btn-sm btn-default" onClick={(e)=> this.buscarClick(e)} >
                    <i className="fa fa-search"></i> Buscar
                  </button>
                </div>
            </div>

         
          </section>


            <section className="content">
              <h5 className="text-bold">
                Programacion Actual
              </h5>
              

              <div className="col-md-10">
                <div className="card">

                  <div className="card-body">
                    {/*-- */}
                    <div className="row">
                      <table className='table table-striped table-hover' width='100%' align='center'>
                        <thead>

                          <tr>
                            <th>Cod. Prog.</th>
                            <th>Carrera</th>
                            <th>Sigla</th>
                            <th>Materia</th>
                            <th>Grupo</th>
                            <th>Accion</th>
                          </tr>

                        </thead>
                        <tbody>
                          {/* className='text-left' */}

                          {this.state.data.map((item, index) => (
                            <tr key={index}>
                             
                              <td>{item.id_progra}</td>
                              <td>{item.nombreca}</td>
                              <td>{item.sigla}</td>
                              <td>{item.nombre}</td>
                              <td>{item.id_grupo}
                              {/*<NuDropdown
                                  className="form-control1"
                                  mame='id_grupo'
                                  options={this.state.options}
                                  value={ item.id_grupo }
                                  onChange={(e) => this.handleCellChange(index,"id_grupo", e.target.value)} 
                                  
                              />*/}
                              </td>

                              <td>
                                <div className='btn-group'>
                                  <Button className='btn btn-warning btn-sm' title='Editar'
                                    onClick={() => this.editar(item)}>
                                    <i className='fa fa-edit'></i>
                                  </Button>
                                  &nbsp;
                                  <Button className='btn btn-danger btn-sm' title='Eliminar'
                                    onClick={() => this.eliminar(item)}  >
                                    <i className='fa fa-trash'></i>
                                  </Button>
                                  
                                </div>
                              </td>
                            </tr>
                          ))}



                        </tbody>
                      </table>
                    </div>
                    {/*-- */}



                  </div>

                  <div className="card-footer">
                    <div className="form-group">
                      <div className="text-center">
                        {/*<Button onClick={this.aceptar_click} className="btn btn-primary">
                          <i className="fa fa-floppy-o"></i>&nbsp;
                          Guardar
                        </Button>
                        &nbsp;
                        <Link to='/DocenteList' className="btn btn-default">Volver</Link>
                          */}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-md-2">

              </div>
            </section>
          </div>

         
          <NuInputBox modalShow={ this.state.modalShow } 
                  titulo="Entrada" 
                  mensaje="Cedula de identidad C.I." 
                  handleOK={ this.handleOK } 
                  handleCancel={ this.handleCancel } />
          

          <ModalProgramacion
            ref={this.modalRef}
            okModal={this.okModal}
            closeModal={this.closeModal}
            nomape={ this.state.form.nomape}
          />

          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(PrograCambiaGrupo);